import type { AxisSpec } from "../../ChartSpec";

/** Vertical room one value tag needs. Also the minimum gap when they are pushed apart. */
export const TAG_MIN_GAP_PX = 15;

/** A bare number needs one unit on the panel, or one stream per axis with its unit in the header, and room for a tag per series. */
export function hoverTagsFit({
    axes,
    streams,
    plotHeightPx,
}: {
    axes: AxisSpec[];
    streams: ReadonlyArray<{ axisId: string }>;
    plotHeightPx: number;
}): boolean {
    const oneUnit = new Set(axes.map((axis) => axis.unitCategory)).size === 1;

    // One stream per axis on a two-axis panel: the header names each side's unit, so a bare number still reads.
    const sides = new Set(axes.map((axis) => axis.side));
    const streamAxes = new Set(streams.map((stream) => stream.axisId));
    const oneStreamPerAxis = axes.length === 2 && sides.size === 2 && streams.length === 2 && streamAxes.size === 2;

    // Sized for every tag landing in one column, since edge clipping can push them all to one side.
    return (oneUnit || oneStreamPerAxis) && streams.length * TAG_MIN_GAP_PX <= plotHeightPx;
}
